var _path, _rect, _ellipse, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndoorFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20V12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12V20H2Z",
    fill: "#4A5568",
    stroke: "#2D3748",
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 6,
    height: 6,
    fill: "#718096"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 9,
    rx: 3.5,
    ry: 2,
    fill: "#8B4513",
    stroke: "#5D3A1A",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7.5,
    x2: 12,
    y2: 10.5,
    stroke: "white",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 8.5,
    x2: 11,
    y2: 8.5,
    stroke: "white",
    strokeWidth: 0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 9,
    x2: 11,
    y2: 9,
    stroke: "white",
    strokeWidth: 0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 9.5,
    x2: 11,
    y2: 9.5,
    stroke: "white",
    strokeWidth: 0.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 8.5,
    x2: 13.5,
    y2: 8.5,
    stroke: "white",
    strokeWidth: 0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 9,
    x2: 13.5,
    y2: 9,
    stroke: "white",
    strokeWidth: 0.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 9.5,
    x2: 13.5,
    y2: 9.5,
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFootball);
export default __webpack_public_path__ + "static/media/indoor-football.e6a3fae672bc8c7edabf2f8507aeaa98.svg";
export { ForwardRef as ReactComponent };